import { IApplicationState } from '../../types/redux';
import { selectUser } from './selectUser';

export const selectIsUserAuthenticated = (state: IApplicationState): boolean => {
  return Boolean(selectUser(state));
};
